import { CurvePath } from "../tween/CurvePath";
import { Keyframe } from "./Keyframe";
export class PathPointKeyframe extends Keyframe {
    cloneTo(destObject) {
        super.cloneTo(destObject);
        if (!destObject.value) {
            destObject.value = new CurvePath();
        }
        console.warn("PathPointKeyframe.cloneTo() not implemented yet.");
    }
    clone() {
        let f = new PathPointKeyframe();
        this.cloneTo(f);
        return f;
    }
}
